module.exports = __webpack_public_path__ + "static/media/archero-icon@2x.c2ceb68e.png";